import {getLoader, logger} from '@react-native-community/cli-tools';
import execa from 'execa';
import fs from 'fs';
import path from 'path';

const createGitRepository = async (folder: string) => {
  const loader = getLoader();

  try {
    await execa('git', ['--version'], {stdio: 'ignore'});
  } catch {
    loader.fail('Unable to initialize Git repo. `git` not in $PATH.');
    return;
  }

  try {
    await execa('git', ['rev-parse', '--is-inside-work-tree'], {
      stdio: 'ignore',
      cwd: folder,
    });
    loader.succeed(
      'New project is already inside of a Git repo, skipping git init.',
    );
    return;
  } catch {}

  loader.start('Initializing Git repository');

  let version;

  try {
    version = JSON.parse(
      fs.readFileSync(
        path.join('node_modules/react-native/package.json'),
        'utf8',
      ),
    ).version;
  } catch {}

  try {
    await execa('git', ['init'], {cwd: folder});
    await execa('git', ['branch', '-M', 'main'], {cwd: folder});
    await execa('git', ['add', '.'], {cwd: folder});
    await execa(
      'git',
      [
        'commit',
        '-m',
        `Initial commit\n\n${
          version ? 'Generated by react-native@' + version : ''
        }`,
      ],
      {
        cwd: folder,
      },
    );
    loader.succeed();
  } catch (e) {
    loader.fail(
      'Could not create an empty Git repository, see debug logs with --verbose',
    );
    logger.debug(e as string);
  }
};

export default createGitRepository;
